import { useState } from "react";

export default function SubscribeSection() {
  const [subscribed, setSubscribed] = useState(false);

  return (
    <section id="subscribe" className="bg-[#2a2318] pb-16 md:pb-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <div className="relative overflow-hidden rounded-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20warm%20abstract%20editorial%20banner%20of%20soft%20coral%20amber%20and%20cream%20gradient%20with%20scattered%20polaroid%20photo%20tiles%20and%20thin%20lines%2C%20magazine%20collage%20background%2C%20warm%20honey%20glow%2C%20no%20text%2C%20high%20detail&width=1600&height=520&seq=cta-subscribe-2641&orientation=landscape"
            alt="9看料 开启追更背景图"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#2a2318]/92 via-[#2a2318]/70 to-[#b8431f]/20" />
          <div className="relative px-6 py-14 md:px-14 md:py-16">
            <div className="max-w-2xl">
              <p className="inline-flex items-center gap-2 rounded-full border border-[#f2d6a4] px-3 py-1 text-xs font-semibold tracking-[0.15em] text-[#ffd791]">
                <i className="ri-notification-3-line" />
                追更提醒 · 可选
              </p>
              <h2 className="font-display mt-5 text-3xl font-black leading-tight text-[#fff6e6] md:text-5xl">
                不错过下一套
                <br />
                <span className="text-[#ffb15c]">九宫格猛料</span>
              </h2>
              <p className="mt-4 max-w-lg text-[15px] leading-7 text-[#f2e7d0]">
                新图集上线时会第一时间整理好九宫格与关键截图。纯浏览页不会收集任何资料，点一下就完成，随看随走。
              </p>
              <div className="mt-7">
                {subscribed ? (
                  <div className="inline-flex items-center gap-2 rounded-full bg-[#2f7d43]/90 px-5 py-3 text-sm font-semibold text-white">
                    <i className="ri-checkbox-circle-fill" />
                    追更已开启，新九图第一时间见
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => setSubscribed(true)}
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-[#fff6e6] px-6 py-3 text-sm font-bold text-[#b43a17] transition hover:bg-white"
                  >
                    <i className="ri-notification-3-line" />
                    开启追更提醒
                    <i className="ri-arrow-right-line" />
                  </button>
                )}
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-4 text-[11px] text-[#b8a47f]">
                <span className="flex items-center gap-1">
                  <i className="ri-shield-check-line text-[#ffb15c]" />
                  无需登录
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-refresh-line text-[#ffb15c]" />
                  随时可关
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-speed-line text-[#ffb15c]" />
                  即时提醒
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}